import React from 'react';

export function hideOnError(event: React.SyntheticEvent<HTMLImageElement, Event>) {
    const target = event.target as HTMLImageElement;
    target.style.display = 'none';
}
